export const DMN_ORIGEM_SISTEMA = {
  PORTAL: 1,
  MOBILE: 2
}